export default "__VITE_ASSET__E75pmhK0__"